<script lang="ts">
    import imgSrc from '../../../img/brand/verbis-pictogram-orange.svg?inline';
</script>

<span class="icon-wrapper icon-wrapper-verbis-pictogram-orange {$$props.class}" style={$$props.style}>
    {@html imgSrc}
</span>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    :global {
        .icon-wrapper-verbis-pictogram-orange path {
            fill: var(--brand-orange-new);
        }
    }
</style>